import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { environment } from '../../../../../environments/environment';
import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { SolicitudRequerimientoDTO } from '../../../../core/models/titulacion/solicitudRequerimiento-DTO';
import { BodyResponse } from 'src/app/core/models/general/body-response';

const API_URL = environment.apiUrlTitulacion;

@Injectable()
export class SolicitudRequerimientoService {
    header = new Headers({ 'Content-Type': 'application/json' });

    constructor(private http: HttpClient) {}

    getSolicitudRequerimientoService() {
        return this.http.get<BodyListResponse<SolicitudRequerimientoDTO>>(
            API_URL + '/api/v1/solicitudRequerimiento/todos'
        );
    }

    guardarSolicitudRequerimientoService(solicitudRequerimientoDTO: SolicitudRequerimientoDTO) {
        return this.http.post(API_URL + '/api/v1/solicitudRequerimiento', solicitudRequerimientoDTO);
    }

    getSolicitudRequerimientoPorCodigoSolicitudRequerimientoService(codigoSolicitudRequerimiento: string) {
        return this.http.get<BodyResponse<SolicitudRequerimientoDTO>>(
            API_URL + '/api/v1/solicitudRequerimiento/' + codigoSolicitudRequerimiento
        );
    }
}
